import React from 'react';
import { FadeIn, CTAButton, Section } from './Shared';
import { useCountdown } from '../hooks/useCountdown';
import { ShieldCheck, Lock, CreditCard, Star, XCircle } from 'lucide-react';
export const UrgencyBar = () => {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <div className="bg-bg-card text-txt-primary py-2 md:py-3 px-3 md:px-4 sticky top-0 z-50 shadow-md border-b border-line" data-id="element-308">
      <div className="max-w-4xl mx-auto flex flex-row items-center justify-center gap-1.5 md:gap-6 text-center text-[11px] md:text-base font-medium" data-id="element-309">
        <div className="flex items-center gap-1 md:gap-2" data-id="element-310">
          <span className="animate-pulse hidden md:inline" data-id="element-311">⏰</span>
          <span className="hidden md:inline" data-id="element-312">
            PRECIO DE LANZAMIENTO — CIERRA EN:
          </span>
          <span className="md:hidden" data-id="element-313">LANZAMIENTO —</span>
          <span className="font-bold bg-white/10 px-1.5 md:px-2 py-0.5 md:py-1 rounded text-xs md:text-base" data-id="element-314">
            {hours.toString().padStart(2, '0')}:
            {minutes.toString().padStart(2, '0')}:
            {seconds.toString().padStart(2, '0')}
          </span>
        </div>
        <span className="text-brandOrange font-bold text-[10px] md:text-base" data-id="element-315">
          Sube el precio. No vuelve.
        </span>
      </div>
    </div>;
};
export const Hero = () => {
  return <section className="bg-bg-base px-4 pt-4 pb-7 md:pt-16 md:pb-16 overflow-hidden" data-id="element-316">
      <div className="max-w-[700px] mx-auto text-center space-y-2.5 md:space-y-6" data-id="element-317">
        <FadeIn data-id="element-318">
          <div className="space-y-2 md:space-y-4" data-id="element-319">
            <div className="inline-flex items-center gap-1.5 bg-bg-card text-brandOrange font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[11px] px-3 py-1 md:px-4 md:py-1.5 rounded-full border border-brandOrange/30" data-id="element-320">
              <span className="text-sm md:text-base" data-id="element-321">🏋️</span>
              <span className="text-[8.5px]" data-id="element-322">MEGAPACK FUNCIONAL 365™</span>
            </div>
            <h1 className="font-hero font-normal uppercase text-[32px] md:text-[72px] leading-[1.0] tracking-[0.5px] text-txt-primary px-2 pt-3 pb-1" data-id="element-323">
              TODAS TUS CLASES DE{' '}
              <span className="text-brandOrange" data-id="element-324">FUNCIONAL</span>
              <br data-id="element-325" />
              <span data-id="element-326">LISTAS. DESDE HOY.</span>
            </h1>
            <p className="text-txt-body text-[12.5px] md:text-[16px] leading-[1.4] md:leading-[1.7] font-sans px-3" data-id="element-327">
              365 sesiones · Warm-ups · Circuitos · Clases listas · WODs
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.15} data-id="element-328">
          <a href="#pricing" className="block cursor-pointer relative" data-id="element-329">
            <div className="absolute inset-0 bg-brandOrange/15 blur-[80px] rounded-full" data-id="element-330"></div>
            <div className="absolute inset-y-0 -inset-x-10 bg-brandBlue-electric/10 blur-[60px] rounded-full" data-id="element-331"></div>
            <img src="https://cdn.magicpatterns.com/uploads/gQtkVod4u9DhJDMUTT1MKv/mockup_sticker.png" alt="MEGAPACK Funcional 365 — Mockup completo del producto" loading="eager" decoding="async"
          // @ts-ignore
          fetchpriority="high" className="relative block w-full max-w-[260px] md:max-w-[520px] mx-auto h-auto object-contain hover:-translate-y-1 transition-transform duration-300 drop-shadow-2xl" data-id="element-332" />
          </a>
        </FadeIn>

        <FadeIn delay={0.25} data-id="element-333">
          <div className="max-w-2xl mx-auto space-y-2.5 md:space-y-5" data-id="element-334">
            {/* Chips - same on all screens */}
            <div className="flex flex-wrap gap-1.5 md:gap-2 justify-center items-center" data-id="element-335">
              <span className="bg-bg-card text-txt-body px-2.5 py-1 md:px-3 md:py-1.5 rounded-full text-[10.5px] md:text-sm font-sans border border-line inline-flex items-center gap-1 whitespace-nowrap" data-id="element-336">
                <span className="text-[10px] md:text-xs" data-id="element-337">📄</span> 100% PDF
              </span>
              <span className="bg-bg-card text-txt-body px-2.5 py-1 md:px-3 md:py-1.5 rounded-full text-[10.5px] md:text-sm font-sans border border-line inline-flex items-center gap-1 whitespace-nowrap" data-id="element-338">
                <span className="text-[10px] md:text-xs" data-id="element-339">⚡</span> Acceso en 5
                min
              </span>
              <span className="bg-bg-card text-txt-body px-2.5 py-1 md:px-3 md:py-1.5 rounded-full text-[10.5px] md:text-sm font-sans border border-line inline-flex items-center gap-1 whitespace-nowrap" data-id="element-340">
                <span className="text-[10px] md:text-xs" data-id="element-341">📚</span> 365 sesiones
              </span>
            </div>

            {/* CTA button + trust */}
            <div className="space-y-2 md:space-y-3" data-id="element-342">
              <CTAButton href="#pricing" fullWidth className="!py-3.5 md:!py-4 !text-[15px] md:!text-base" data-id="element-343">
                💪 QUIERO EL MEGAPACK AHORA
              </CTAButton>

              <div className="flex flex-wrap items-center justify-center gap-2 md:gap-4 text-[9.5px] md:text-xs text-txt-muted font-sans" data-id="element-344">
                <span className="flex items-center gap-1" data-id="element-345">
                  <ShieldCheck size={11} className="text-success" data-id="element-346" /> Garantía 15
                  días
                </span>
                <span className="flex items-center gap-1" data-id="element-347">
                  <Lock size={11} className="text-txt-muted" data-id="element-348" /> Pago seguro
                </span>
                <span className="flex items-center gap-1" data-id="element-349">
                  <CreditCard size={11} className="text-brandBlue-electric" data-id="element-350" />{' '}
                  Mercado Pago
                </span>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};
export const SocialProof = () => {
  return <div className="bg-bg-alt border-y border-line py-6" data-id="element-351">
      <div className="max-w-[1100px] mx-auto px-6" data-id="element-352">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center divide-x divide-line" data-id="element-353">
          <FadeIn delay={0.1} data-id="element-354">
            <div className="font-display font-black text-[30px] md:text-[44px] leading-[1.1] text-brandOrange mb-0.5" data-id="element-355">
              +300
            </div>
            <div className="text-sm font-sans text-txt-body" data-id="element-356">
              coaches confían
            </div>
          </FadeIn>
          <FadeIn delay={0.2} data-id="element-357">
            <div className="font-display font-black text-[30px] md:text-[44px] leading-[1.1] text-brandOrange mb-0.5" data-id="element-358">
              6
            </div>
            <div className="text-sm font-sans text-txt-body" data-id="element-359">Tomos listos</div>
          </FadeIn>
          <FadeIn delay={0.3} data-id="element-360">
            <div className="font-display font-black text-[30px] md:text-[44px] leading-[1.1] text-brandOrange mb-0.5" data-id="element-361">
              5
            </div>
            <div className="text-sm font-sans text-txt-body" data-id="element-362">
              Bonos incluidos
            </div>
          </FadeIn>
          <FadeIn delay={0.4} data-id="element-363">
            <div className="font-display font-black text-[30px] md:text-[44px] leading-[1.1] text-brandOrange mb-0.5" data-id="element-364">
              4.9/5
            </div>
            <div className="text-sm font-sans text-txt-body flex items-center justify-center gap-1" data-id="element-365">
              calificación <Star size={12} className="fill-gold text-gold" data-id="element-366" />
            </div>
          </FadeIn>
        </div>
      </div>
    </div>;
};
export const Testimonials1 = () => {
  const testimonials = [{
    initials: 'MR',
    text: 'Llegué al lunes con todo listo por primera vez en años. Los warm-ups me salvaron.',
    author: 'Marcos R.',
    role: 'Coach de Funcional · Bs. As.',
    bg: 'bg-brandOrange'
  }, {
    initials: 'CP',
    text: 'Tengo grupos de distintos niveles. El kit de adaptaciones cambió todo.',
    author: 'Carolina P.',
    role: 'Instructora · Córdoba',
    bg: 'bg-brandBlue-electric'
  }, {
    initials: 'DG',
    text: 'En 10 minutos tengo la clase del lunes armada. Mis alumnos notan la diferencia.',
    author: 'Diego G.',
    role: 'Profe de Box · Rosario',
    bg: 'bg-brandOrange'
  }];
  return <Section className="bg-bg-base" data-id="element-367">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-2.5 md:gap-4" data-id="element-368">
        {testimonials.map((t, i) => <FadeIn key={i} delay={Math.min(i * 0.05, 0.2)} data-id="element-369">
            <div className="bg-bg-card p-3.5 md:p-5 rounded-[14px] md:rounded-[18px] border border-line h-full flex flex-col" data-id="element-370">
              <div className="flex items-center gap-2.5 mb-2.5" data-id="element-371">
                <div className={`w-8 h-8 md:w-9 md:h-9 ${t.bg} text-white rounded-full flex items-center justify-center font-sans font-bold text-[11px] md:text-xs shrink-0`} data-id="element-372">
                  {t.initials}
                </div>
                <div className="min-w-0" data-id="element-373">
                  <div className="flex text-gold mb-0.5" data-id="element-374">
                    {[...Array(5)].map((_, j) => <Star key={j} size={10} className="fill-current" data-id="element-375" />)}
                  </div>
                  <p className="font-sans font-bold text-txt-primary text-[12px] md:text-[13px] leading-tight" data-id="element-376">
                    {t.author}
                  </p>
                  <p className="text-[10px] md:text-[11px] font-sans text-txt-muted" data-id="element-377">
                    {t.role}
                  </p>
                </div>
              </div>
              <p className="text-txt-body font-sans text-[12.5px] md:text-[13.5px] leading-[1.5] italic" data-id="element-378">
                "{t.text}"
              </p>
            </div>
          </FadeIn>)}
      </div>
    </Section>;
};
export const Problem = () => {
  const painPoints = ['Llegás al gym sin saber exactamente qué clase dar hoy', 'Pasás horas del domingo buscando ejercicios en Instagram que nunca quedan bien para tu grupo', 'Siempre los mismos circuitos porque no tenés un banco de sesiones serio', 'El alumno nuevo llega y no sabés cómo adaptarle la clase en el momento', 'Querés un programa anual estructurado pero no tenés tiempo de armarlo', 'Tu grupo se estanca porque no hay progresión real de semana en semana', 'Fin de semana agotado y el domingo a la noche volvés a empezar el mismo ciclo'];
  return <Section className="bg-bg-alt" data-id="element-379">
      <div className="max-w-[720px] mx-auto" data-id="element-380">
        <FadeIn data-id="element-381">
          <h2 className="font-display font-extrabold uppercase md:text-[44px] text-center mb-8 text-txt-primary text-[28px]" data-id="element-382">
            Si sos profe de <span className="text-brandOrange" data-id="element-383">funcional,</span>
            <br data-id="element-384" />
            esto te va a sonar familiar...
          </h2>

          <div className="space-y-2 md:space-y-3 mb-10" data-id="element-385">
            {painPoints.map((point, i) => <div key={i} className="flex items-start gap-2.5 bg-bg-card border border-line rounded-[10px] py-2.5 px-3 md:py-3 md:px-4" data-id="element-386">
                <XCircle className="text-danger shrink-0 mt-0.5" size={16} data-id="element-387" />
                <p className="text-txt-body font-sans text-[13px] md:text-[15px] leading-[1.5]" data-id="element-388">
                  {point}
                </p>
              </div>)}
          </div>

          {/* Neon divider */}
          <div className="h-[2px] w-32 md:w-48 mx-auto rounded-full mb-10 md:mb-12" style={{
          background: 'linear-gradient(90deg, transparent 0%, #FF6B00 50%, transparent 100%)',
          boxShadow: '0 0 12px rgba(255,107,0,0.8), 0 0 24px rgba(255,107,0,0.5)'
        }} data-id="element-389"></div>

          <h3 className="font-display font-extrabold uppercase md:text-[52px] text-center text-txt-primary mb-8 relative text-[30px]" data-id="element-390">
            ¿Cuánto tiempo más vas a{' '}
            <span className="text-brandOrange inline-block" style={{
            textShadow: '0 0 20px rgba(255,107,0,0.6), 0 0 40px rgba(255,107,0,0.4)'
          }} data-id="element-391">
              improvisar?
            </span>
          </h3>

          <div className="space-y-4 text-txt-body font-sans text-[15px] md:text-base leading-[1.7] mb-10" data-id="element-392">
            <p data-id="element-393">
              Elegiste esta profesión porque amás el entrenamiento funcional y
              ver a tu grupo crecer.
            </p>
            <p data-id="element-394">
              Pero nadie te dijo que ibas a perder tiempo buscando circuitos que
              no encajan con tu grupo, armando sesiones a último momento y
              llegando el lunes improvisando algo que "más o menos sirve".
            </p>
          </div>

          {/* Highlighted closing question */}
          <div className="relative bg-bg-card border-2 border-brandOrange rounded-[16px] py-5 px-5 md:py-6 md:px-8 shadow-[0_0_40px_rgba(255,107,0,0.25)]" data-id="element-395">
            <p className="font-display font-extrabold text-[20px] md:text-[28px] leading-[1.2] text-center text-txt-primary" data-id="element-396">
              ¿Y SI ESTA FUERA LA{' '}
              <span className="text-brandOrange" data-id="element-397">ÚLTIMA CLASE</span>
              <br data-id="element-398" />
              QUE PREPARÁS ASÍ?
            </p>
          </div>

          {/* Neon divider — transition to product */}
          <div className="h-[2px] w-32 md:w-48 mx-auto rounded-full mt-10 md:mt-14" style={{
          background: 'linear-gradient(90deg, transparent 0%, #FF6B00 50%, transparent 100%)',
          boxShadow: '0 0 12px rgba(255,107,0,0.8), 0 0 24px rgba(255,107,0,0.5)'
        }} data-id="element-399"></div>
        </FadeIn>
      </div>
    </Section>;
};